import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import React, { useEffect, useCallback } from 'react';
import { useNotificationData } from 'lib/entities/notification/useNotificationData';
import NotificationItem from './NotificationItem';

function NotificationList() {
  const isLoading = useNotificationData((store) => store.isLoading);
  const tab = useNotificationData((store) => store.tab);
  const displayedList = useNotificationData(
    (store) => store.contents[tab].list,
  );

  const closePopup = useNotificationData((store) => store.closePopup);
  const setConvoOpen = useNotificationData((store) => store.setConvoOpen);
  const getNotification = useNotificationData((store) => store.getNotification);
  const markNotifAsRead = useNotificationData((store) => store.markNotifAsRead);

  const getAwaitNotification = useCallback(
    async (t) => {
      await getNotification(t);
    },
    [tab],
  );

  useEffect(() => {
    getAwaitNotification(tab);
    const timeoutId = setTimeout(() => markNotifAsRead(tab), 200);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [tab]);

  if (displayedList.length === 0 && !isLoading) {
    return (
      <Flex align="center" justify="center" height="60px">
        <Text color={color.highgray}>
          You do not have any notification right now
        </Text>
      </Flex>
    );
  }

  return (
    <>
      {displayedList.map((item) => (
        <NotificationItem
          item={item}
          key={`${tab}-${item.id}-${displayedList.length}`}
          onClickConversationNotif={({ id, visible }) => {
            setConvoOpen(id, visible);
            closePopup();
          }}
        />
      ))}
    </>
  );
}

export default React.memo(NotificationList);
